import { TStore } from "../../hooks/useService";
import { POST, respond } from "../Helpers";
import { TGetPvcCenterAddressesData, TGetPvcCenterAddressesService } from "./types";

export const getPvcCenterAddresses: TGetPvcCenterAddressesService = (
  params
) => {
  return async (store: TStore) => {
    const { setPvcAddresses } = store.authStore
    const { data, error } = await POST<TGetPvcCenterAddressesData>(
      "/getPvcCenterAddresses",
      { ...params },
      true
    );
    if(data) setPvcAddresses(data)
    return respond(data, error);
  };
};
